<div class="dashboard-container">
  <app-user-board></app-user-board>
  <app-transactions-table></app-transactions-table>
  <app-bulk-verify-pill-loader *ngIf="bulkVerifyInProgress$ | async"></app-bulk-verify-pill-loader>
</div>
